import {formsStore} from '../stores/FormsStore';
import {statusColorScheme} from '../../../constants/statuses';

export function getCurrentFormStatusColor(statusName: string, tableName?: string): string {
    const form = tableName ? formsStore.getForm(tableName) : formsStore.currentForm;
    return form?.statuses?.get(statusName) ?? statusColorScheme.colorWhite;
}

export function getStatusBorderColor(statusColor: string): string {
    return statusColor === statusColorScheme.colorWhite
        ? statusColorScheme.colorBlack
        : statusColor;
}
